import { render, staticRenderFns } from "./UsersGroup.vue?vue&type=template&id=590b0dcc&scoped=true"
import script from "./UsersGroup.vue?vue&type=script&lang=js"
export * from "./UsersGroup.vue?vue&type=script&lang=js"
import style0 from "./UsersGroup.vue?vue&type=style&index=0&id=590b0dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b0dcc",
  null
  
)

export default component.exports